import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class LawpayPaymentService {

  private url: string = 'lawpay_payments';

  constructor(private httpClient: HttpClientService) {}

  // Get list of payments with optional filters
  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  // Get a single payment by ID
  show(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}.json`);
  }

  // Get search/filter options
  getSearchOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}/search_options.json`);
  }

  // Process a payment (prepare for receipt creation)
  processPayment(id: number, contactId?: number, matterId?: number): Promise<any> {
    const data: any = {};
    if (contactId) {
      data.contact_id = contactId;
    }
    if (matterId) {
      data.matter_id = matterId;
    }
    return this.httpClient.post(`${this.url}/${id}/process_payment.json`, data);
  }

  // Preview how a proposed refund will be allocated (LIFO over original Payment Bills)
  refundPreview(id: number, amount?: number): Promise<any> {
    const params: any = {};
    if (amount !== undefined && amount !== null) {
      params.amount = amount;
    }
    return this.httpClient.get(`${this.url}/${id}/refund_preview.json`, params);
  }

  // Refund a payment
  refund(id: number, amount?: number, reason?: string): Promise<any> {
    const data: any = {};
    if (amount !== undefined && amount !== null) {
      data.amount = amount;
    }
    if (reason) {
      data.reason = reason;
    }
    return this.httpClient.post(`${this.url}/${id}/refund.json`, data);
  }

  // Get unprocessed payments count (for badge/notification)
  getUnprocessedCount(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { status: 'unprocessed', per_page: 1 });
  }
}
